import { render, staticRenderFns } from "./uploadScoreFiles.vue?vue&type=template&id=1ad8ec71&scoped=true"
import script from "./uploadScoreFiles.vue?vue&type=script&lang=js"
export * from "./uploadScoreFiles.vue?vue&type=script&lang=js"
import style0 from "./uploadScoreFiles.vue?vue&type=style&index=0&id=1ad8ec71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8ec71",
  null
  
)

export default component.exports